import React, { useState, useEffect, useMemo } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  VStack,
  Stack,
  Button,
  Input,
  Select,
  Textarea,
  Text,
  useToast,
  Card,
  CardHeader,
  CardBody,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { Trash } from "lucide-react";
import { addPriceList, updatePriceList } from "../../../redux/api/priceapi/PriceApi";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getPricelist } from "../../../redux/reduxApi/PriceRedux";
// Mock brandPresets
const brandPresets = {
  adani: {
    acWire: "AC Wire (As per Inverter Guideline)",
    dcWire: "DC Wire (1C 4mm Copper)",
    protectionBox: "ACDB & DCDB (IP65, SPD, MCB & Fuses)",
    earthing: "Earthing Wire 6mm\nEarthing Rod X 3",
    mounting: "STRUCTURE Square Pipe 3″x3″ With 4 mm Base Plate, GI Hot Dip 2.6mm\nAnti-lock System & Z Clamp, U Clamp",
    pvc: "Conduit Pipe, Cable Tray, Flexible",
    additional: "Installation & commissioning including consumables as per site conditions",
  },
  luminous: {
    acWire: "AC Wire (As per Inverter Guideline)",
    dcWire: "DC Wire (1C 4mm Copper)",
    protectionBox: "ACDB & DCDB (IP65, SPD, MCB & Fuses)",
    earthing: "Earthing Wire 6mm\nEarthing Rod X 3",
    mounting: "STRUCTURE Square Pipe 3″x3″ With 4 mm Base Plate, GI Hot Dip 2.6mm\nAnti-lock System & Z Clamp, U Clamp",
    pvc: "Conduit Pipe, Cable Tray, Flexible",
    additional: "Installation & commissioning including consumables as per site conditions",
  },
  havells: {
    acWire: "AC Wire (As per Inverter Guideline)",
    dcWire: "DC Wire (1C 4mm Copper)",
    protectionBox: "ACDB & DCDB (IP65, SPD, MCB & Fuses)",
    earthing: "Earthing Wire 6mm\nEarthing Rod X 3",
    mounting: "STRUCTURE Square Pipe 3″x3″ With 4 mm Base Plate, GI Hot Dip 2.6mm\nAnti-lock System & Z Clamp, U Clamp",
    pvc: "Conduit Pipe, Cable Tray, Flexible",
    additional: "Installation & commissioning including consumables as per site conditions",
  },
};

const PrizeForm = ({ isDrawerOpen, closeDrawer, dataToEdit, isUpdateMode }) => {
  // console.log("dataToEdit", dataToEdit);
  // const toast = useToast();

  const branddata = useSelector((state) => state.utils?.brandList);
  const solarData = useSelector((state) => state.utils?.solarList);
  const dispatch = useDispatch();
  const brandOptions = useMemo(() => {
    return branddata?.map((item) => ({
      label: item?.solarBrandName,
      value: item?.ROWID,
    }));
  }, [branddata]);
  const solarOptions = useMemo(() => {
    return solarData?.map((item) => ({
      label: item?.panelName,
      value: item?.ROWID,
    }));
  }, [solarData]);

  const [formData, setFormData] = useState({
    ROWID: "",
    brand: "",
    solarOption: "",
    monopercSpecifications: [],
    topconSpecifications: [],
    acWire: "AC Wire (As per Inverter Guideline)",
    dcWire: "DC Wire (1C 4mm Copper)",
    protectionBox: "ACDB & DCDB (IP65, SPD, MCB & Fuses)",
    earthing: "Earthing Wire 6mm\nEarthing Rod X 3",
    mounting: "STRUCTURE Square Pipe 3″x3″ With 4 mm Base Plate, GI Hot Dip 2.6mm\nAnti-lock System & Z Clamp, U Clamp",
    pvc: "Conduit Pipe, Cable Tray, Flexible",
    additional: "Installation & commissioning including consumables as per site conditions",
  });

  const [customFields, setCustomFields] = useState([]);

  useEffect(() => {
    const brand = formData.brand;
    if (brand && brandPresets[brand]) {
      setFormData((prev) => ({
        ...prev,
        ...brandPresets[brand],
      }));
    }
  }, [formData.brand]);

  const handelClose = () => {
    setFormData({
      ROWID: "",
      brand: "",
      solarOption: "",
      customSolarOption: "",
      acWire: "",
      dcWire: "",
      protectionBox: "",
      earthing: "",
      mounting: "",
      pvc: "",
      additional: "",
      monopercSpecifications: [],
      topconSpecifications: [],
      acWireRowId: "",
      dcWireRowId: "",
      protectionBoxRowId: "",
      earthingRowId: "",
      mountingRowId: "",
      pvcRowId: "",
      additionalRowId: "",
    });
    closeDrawer();
    // isUpdateMode(false);s
  };
  // Form data state initialization

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMonopercFieldChange = (index, field, value) => {
    const updatedRows = [...formData.monopercSpecifications];
    updatedRows[index] = { ...updatedRows[index], [field]: value };
    setFormData((prev) => ({ ...prev, monopercSpecifications: updatedRows }));
  };

  const handleTopconFieldChange = (index, field, value) => {
    const updatedRows = [...formData.topconSpecifications];
    updatedRows[index] = { ...updatedRows[index], [field]: value };
    setFormData((prev) => ({ ...prev, topconSpecifications: updatedRows }));
  };

  const addMonopercRow = () => {
    setFormData((prev) => ({
      ...prev,
      monopercSpecifications: [...prev.monopercSpecifications, {}],
    }));
  };

  const addTopconRow = () => {
    setFormData((prev) => ({
      ...prev,
      topconSpecifications: [...prev.topconSpecifications, {}],
    }));
  };

  const deleteMonopercRow = (index) => {
    const updatedRows = [...formData.monopercSpecifications];
    updatedRows.splice(index, 1);
    setFormData((prev) => ({ ...prev, monopercSpecifications: updatedRows }));
  };

  const deleteTopconRow = (index) => {
    const updatedRows = [...formData.topconSpecifications];
    updatedRows.splice(index, 1);
    setFormData((prev) => ({ ...prev, topconSpecifications: updatedRows }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const solarPricingSpecifications = [
      ...formData.monopercSpecifications.map((item) => ({
        ROWID: item.ROWID || "", // Preserve ROWID if exists
        solarType: "1ph Monoperc 540-550Wp",
        noOfPanels: item.noOfPanels || "",
        projectKW: item.projectKW || "",
        warranty: item.warranty || "",
        inverterCapacity: item.inverterCapacity || "",
        inverterWarranty: item.inverterWarranty || "",
        totalCost: item.totalCost || "",
        subsidyAmount: item.subsidyAmount || "",
        afterSubsidy: item.afterSubsidy || "",
      })),
      ...formData.topconSpecifications.map((item) => ({
        ROWID: item.ROWID || "", // Preserve ROWID if exists
        solarType: "3ph Topcon 575-595 Wp",
        noOfPanels: item.noOfPanels || "",
        projectKW: item.projectKW || "",
        warranty: item.warranty || "",
        inverterCapacity: item.inverterCapacity || "",
        inverterWarranty: item.inverterWarranty || "",
        totalCost: item.totalCost || "",
        subsidyAmount: item.subsidyAmount || "",
        afterSubsidy: item.afterSubsidy || "",
      })),
    ];

    const priceComponentDetails = [
      ...["acWire", "dcWire", "protectionBox", "earthing", "mounting", "pvc", "additional"].map((key) => ({
        ROWID: formData[key + "RowId"] || "", // Preserve ROWID if exists
        // component: key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()),
        description: formData[key] || "",
      })),
      ...customFields.map((item) => ({
        ROWID: item.ROWID || "", // Preserve ROWID if exists
        component: item.label,
        description: item.value,
      })),
    ];

    const payload = {
      ROWID: formData.ROWID || "", // Include ROWID for update
      brand: formData.brand,
      solar: formData.solarOption,
      solarPricingSpecifications: solarPricingSpecifications,
      priceComponentDetails: priceComponentDetails,
    };

    console.log("payload", payload);
    try {
      if (isUpdateMode) {
        const response = await updatePriceList(payload);
        console.log("Update response", response);
        toast.success("Price list updated successfully!");
      } else {
        const response = await addPriceList({ ...payload, createdBy: localStorage.getItem("email") });
        console.log("Add response", response);
        toast.success("Price list created successfully!");
      }
      dispatch(getPricelist());
      handelClose();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit the form. Please try again.");
    }
  };

  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      const { priceListResponse, solarPricingSpecificationsGrouped, priceComponentDetailsResponse } = dataToEdit;

      // Update form data state with priceListResponse
      setFormData((prev) => ({
        ...prev,
        ROWID: priceListResponse.ROWID || "", // Set the ROWID here
        brand: priceListResponse.brand || "",
        solarOption: priceListResponse.solar || "",
        monopercSpecifications: (solarPricingSpecificationsGrouped["1ph Monoperc 540-550Wp"] || []).map((item) => ({
          ...item,
          ROWID: item.ROWID || "", // Preserve ROWID for monoperc specifications
        })),
        topconSpecifications: (solarPricingSpecificationsGrouped["3ph Topcon 575-595 Wp"] || []).map((item) => ({
          ...item,
          ROWID: item.ROWID || "", // Preserve ROWID for topcon specifications
        })),
      }));

      // Update component details
      const componentDetails = priceComponentDetailsResponse.reduce((acc, item) => {
        // acc[item.component.toLowerCase().replace(/ /g, "")] = {
        //   description: item.description || "",
        //   ROWID: item.ROWID || "", // Preserve ROWID for each component detail
        // };
        return acc;
      }, {});

      // Set the component details using the data from `priceComponentDetailsResponse`
      setFormData((prev) => ({
        ...prev,
        acWire: componentDetails.acwire?.description || "",
        dcWire: componentDetails.dcwire?.description || "",
        protectionBox: componentDetails.protectionbox?.description || "",
        earthing: componentDetails.earthing?.description || "",
        mounting: componentDetails.mounting?.description || "",
        pvc: componentDetails.pvc?.description || "",
        additional: componentDetails.additional?.description || "",
        acWireRowId: componentDetails.acwire?.ROWID || "",
        dcWireRowId: componentDetails.dcwire?.ROWID || "",
        protectionBoxRowId: componentDetails.protectionbox?.ROWID || "",
        earthingRowId: componentDetails.earthing?.ROWID || "",
        mountingRowId: componentDetails.mounting?.ROWID || "",
        pvcRowId: componentDetails.pvc?.ROWID || "",
        additionalRowId: componentDetails.additional?.ROWID || "",
      }));
    }
  }, [isUpdateMode, dataToEdit]); // Watch for changes in edit mode or dataToEdit
  // Watch for changes in edit mode or dataToEdit

  return (
    <Drawer isOpen={isDrawerOpen} placement="right" size="xl" onClose={handelClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader borderBottom="1px" borderColor="gray.100" p={4}>
          {isUpdateMode ? "Update Price List" : "Create Price List"}
        </DrawerHeader>
        <form onSubmit={handleSubmit}>
          <DrawerBody p={4}>
            {/* Solar Type Card */}
            <Card mb={4}>
              <CardBody>
                <FormControl>
                  <Select name="brand" value={formData.brand} onChange={handleChange}>
                    <option value="">Choose brand</option>
                    {brandOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Select>
                  <FormLabel>Brand</FormLabel>
                </FormControl>
                <FormControl>
                  <Select name="solarOption" value={formData.solarOption} onChange={handleChange}>
                    <option value="">Choose Solar Option</option>
                    {solarOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Select>
                  <FormLabel>Panel Type</FormLabel>
                </FormControl>
              </CardBody>
            </Card>

            <Card mb={4}>
              <CardHeader pb={1}>
                <Text fontWeight="bold">1ph Monoperc 540-550Wp</Text>
              </CardHeader>
              <CardBody pt={1}>
                <TableContainer>
                  <Table
                    size="sm"
                    style={{
                      border: "1px solid #dee2e6",
                      borderCollapse: "collapse",
                    }}
                  >
                    <Thead>
                      <Tr>
                        <Th
                          style={{
                            border: "1px solid #dee2e6",
                            backgroundColor: "#f8f9fa",
                            padding: "8px",
                          }}
                        >
                          Action
                        </Th>
                        {["No. of Panels", "Project kW", "Warranty (Years)", "Inverter Capacity", "Inverter Warranty", "Total Cost", "Subsidy Amount", "After Subsidy"].map((header) => (
                          <Th
                            key={header}
                            style={{
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f8f9fa",
                              padding: "8px",
                            }}
                          >
                            {header}
                          </Th>
                        ))}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {formData.monopercSpecifications?.map((row, index) => (
                        <Tr key={index}>
                          <Td
                            style={{
                              border: "1px solid #dee2e6",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            <button
                              onClick={() => deleteMonopercRow(index)}
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                              }}
                            >
                              <Trash size={20} color="#dd0b58" />
                            </button>
                          </Td>
                          {["noOfPanels", "projectKW", "warranty", "inverterCapacity", "inverterWarranty", "totalCost", "subsidyAmount", "afterSubsidy"].map((field) => (
                            <Td
                              key={field}
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              <Input
                                type="text"
                                value={row[field] || ""}
                                placeholder={field.charAt(0).toUpperCase() + field.slice(1).toLowerCase()}
                                name={field}
                                onChange={(e) => handleMonopercFieldChange(index, field, e.target.value)}
                                size="sm"
                              />
                            </Td>
                          ))}
                        </Tr>
                      ))}
                      <Tr>
                        <Td colSpan={9} style={{ textAlign: "left", padding: "8px" }}>
                          <Button
                            onClick={addMonopercRow}
                            style={{
                              backgroundColor: "#FF176B",
                              color: "white",
                              borderRadius: "20px",
                              padding: "8px 16px",
                              cursor: "pointer",
                            }}
                            onMouseOver={(e) => (e.target.style.backgroundColor = "#e6155d")}
                            onMouseOut={(e) => (e.target.style.backgroundColor = "#FF176B")}
                          >
                            Add Row
                          </Button>
                        </Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>

            <Card mb={4}>
              <CardHeader pb={1}>
                <Text fontWeight="bold">3ph Topcon 575-595 Wp</Text>
              </CardHeader>
              <CardBody pt={1}>
                <TableContainer>
                  <Table
                    size="sm"
                    style={{
                      border: "1px solid #dee2e6",
                      borderCollapse: "collapse",
                    }}
                  >
                    <Thead>
                      <Tr>
                        <Th
                          style={{
                            border: "1px solid #dee2e6",
                            backgroundColor: "#f8f9fa",
                            padding: "8px",
                          }}
                        >
                          Action
                        </Th>
                        {["No. of Panels", "Project kW", "Warranty (Years)", "Inverter Capacity", "Inverter Warranty", "Total Cost", "Subsidy Amount", "After Subsidy"].map((header) => (
                          <Th
                            key={header}
                            style={{
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f8f9fa",
                              padding: "8px",
                            }}
                          >
                            {header}
                          </Th>
                        ))}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {formData.topconSpecifications?.map((row, index) => (
                        <Tr key={index}>
                          <Td
                            style={{
                              border: "1px solid #dee2e6",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            <button
                              onClick={() => deleteTopconRow(index)}
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                              }}
                            >
                              <Trash size={20} color="#dd0b58" />
                            </button>
                          </Td>
                          {["noOfPanels", "projectKW", "warranty", "inverterCapacity", "inverterWarranty", "totalCost", "subsidyAmount", "afterSubsidy"].map((field) => (
                            <Td
                              key={field}
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              <Input
                                type="text"
                                value={row[field] || ""}
                                placeholder={field.charAt(0).toUpperCase() + field.slice(1).toLowerCase()}
                                name={field}
                                onChange={(e) => handleTopconFieldChange(index, field, e.target.value)}
                                size="sm"
                              />
                            </Td>
                          ))}
                        </Tr>
                      ))}
                      <Tr>
                        <Td colSpan={9} style={{ textAlign: "left", padding: "8px" }}>
                          <Button
                            onClick={addTopconRow}
                            style={{
                              backgroundColor: "#FF176B",
                              color: "white",
                              borderRadius: "20px",
                              padding: "8px 16px",
                              cursor: "pointer",
                            }}
                            onMouseOver={(e) => (e.target.style.backgroundColor = "#e6155d")}
                            onMouseOut={(e) => (e.target.style.backgroundColor = "#FF176B")}
                          >
                            Add Row
                          </Button>
                        </Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>

            {formData.brand && (
              <Card mb={4}>
                <CardHeader pb={1}>
                  <Text fontWeight="bold">Component Details</Text>
                </CardHeader>
                <CardBody pt={1}>
                  <TableContainer>
                    <Table
                      size="sm"
                      style={{
                        border: "1px solid #dee2e6",
                        borderCollapse: "collapse",
                      }}
                    >
                      <Thead>
                        <Tr>
                          <Th
                            style={{
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f8f9fa",
                              padding: "8px",
                            }}
                            width="40%"
                          >
                            Component
                          </Th>
                          <Th
                            style={{
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f8f9fa",
                              padding: "8px",
                            }}
                          >
                            Description
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {[
                          { label: "AC Wire", name: "acWire" },
                          { label: "DC Wire", name: "dcWire" },
                          { label: "Protection Box", name: "protectionBox" },
                          { label: "Earthing System", name: "earthing" },
                          { label: "Mounting Structure", name: "mounting" },
                          { label: "PVC Works", name: "pvc" },
                          { label: "Additional Requirements", name: "additional" },
                        ].map((field) => (
                          <Tr key={field.name}>
                            <Td
                              style={{
                                fontWeight: "600",
                                backgroundColor: "#f9f9f9",
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              {field.label}
                            </Td>
                            <Td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              <Textarea placeholder={`Enter ${field.label}`} name={field.name} value={formData[field.name] || ""} onChange={handleChange} size="sm" resize="vertical" />
                            </Td>
                          </Tr>
                        ))}

                        {/* Custom Fields */}
                        {customFields.map((field, index) => (
                          <Tr key={index}>
                            <Td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              <Input
                                placeholder="Enter Component Name"
                                value={field.label}
                                onChange={(e) => {
                                  const updated = [...customFields];
                                  updated[index].label = e.target.value;
                                  setCustomFields(updated);
                                }}
                                size="sm"
                              />
                            </Td>
                            <Td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              <Stack direction="row" align="flex-start">
                                <Textarea
                                  placeholder="Enter Component Description"
                                  value={field.value}
                                  onChange={(e) => {
                                    const updated = [...customFields];
                                    updated[index].value = e.target.value;
                                    setCustomFields(updated);
                                  }}
                                  size="sm"
                                  resize="vertical"
                                />
                                <Button
                                  size="sm"
                                  className="create-button"
                                  onClick={() => {
                                    const updated = [...customFields];
                                    updated.splice(index, 1);
                                    setCustomFields(updated);
                                  }}
                                >
                                  <Trash />
                                </Button>
                              </Stack>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>

                  {/* Add Field Button */}
                  <Button
                    onClick={() => setCustomFields([...customFields, { label: "", value: "" }])}
                    mt={4}
                    style={{
                      backgroundColor: "#FF176B",
                      color: "white",
                      borderRadius: "20px",
                      padding: "8px 16px",
                      cursor: "pointer",
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#e6155d")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "#FF176B")}
                    size="sm"
                  >
                    Add Field
                  </Button>
                </CardBody>
              </Card>
            )}

            {/* Footer Buttons */}
          </DrawerBody>
          <DrawerFooter justifyContent="center" borderTop="1px" borderColor="gray.100" mt={4}>
            <div className="gap-3 d-flex">
              <Button variant="outline" className="cancel-button" onClick={handelClose}>
                Cancel
              </Button>
              <Button type="submit" className="create-button">
                {isUpdateMode ? "Update" : "Create"}
              </Button>
            </div>
          </DrawerFooter>
        </form>
      </DrawerContent>
    </Drawer>
  );
};

export default PrizeForm;
